import gql from 'graphql-tag';
import React from 'react';
import { View, Image } from 'react-native';
import { Text } from '../../components'; import { getProductImageUrl } from '../../../common/utils/products/productImageUrlResolver';
import { colors } from '../../theme';
import { Icon } from '../icon';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_PRODUCTS = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: ProductPageFilter
	) {
		getProducts(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
				imageUrl
				isFavourite
				HCGCategory
				HFDCategory
				size
				sizeUnit
				measurementUnit
				barcodes
				disabledForPlanograms
				tags {
					id
				}
			}
			count
		}
	}
`;

const ProductSelector = (props) => {
	const { query, restrictedProductTags, blockDisabledProducts } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_PRODUCTS}
			initialSortBy="isFavourite_name"
			disabledItemPredicate={item => blockDisabledProducts && item.disabledForPlanograms || item.tags?.some(tag => restrictedProductTags?.some(rpt => rpt.id === tag.id))}
			renderItem={item => {
				const isRestricted = blockDisabledProducts && item.disabledForPlanograms || item.tags?.some(tag => restrictedProductTags?.some(rpt => rpt.id === tag.id));

				return (
					<View
						style={{ flex: 1, flexDirection: 'row', alignItems: 'center', paddingLeft: 5, paddingRight: 5 }}
					>
						<Icon
							name={item.isFavourite ? 'starSolid' : 'star'}
							style={{ marginRight: 10, color: item.isFavourite ? '#509acd' : '#CCC' }}
						/>
						<Image
							style={{ minWidth: 30, minHeight: 30, width: 30, height: 30, marginRight: 10, resizeMode: 'contain' }}
							source={{ uri: getProductImageUrl(item) }}
						/>
						{
							isRestricted && (
								<Text style={{ color: colors.RED[3], marginRight: 5, fontSize: 10 }}>Restricted</Text>
							)
						}
						<Text style={{ color: isRestricted ? 'grey' : 'inherit' }}>{ item.name }</Text>
					</View>
				);
			}}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select product"
			{...props}
		/>
	);
};

export default ProductSelector;
